// AuthService.js

import axios from 'axios';

const AUTH_API_URL = 'https://backend.controlease.com.br/api/auth/';
const USER_API_URL = 'https://backend.controlease.com.br/api/users/';

class AuthService {
  async login(credentials) {
    try {
      const response = await axios.post(AUTH_API_URL + 'login', {
        email: credentials.email,
        password: credentials.password,
      });

      if (response.data.token) {
        this.handleLoginSuccess(response.data);
        return { success: true, ...response.data };
      }
      return { success: false, message: 'Login falhou' };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Erro desconhecido ao fazer login',
      };
    }
  }

  async loginWithGoogle(googleData) {
    try {
      const response = await axios.post(AUTH_API_URL + 'google', googleData);

      if (response.data.token) {
        this.handleLoginSuccess(response.data);
        return { success: true, ...response.data };
      }
      return { success: false, message: 'Google login falhou' };
    } catch (error) {
      if (error.response && error.response.status === 403 && error.response.data.requiresSetup) {
        return {
          success: false,
          requiresSetup: true,
          ...error.response.data
        };
      }
      return {
        success: false,
        message: error.response?.data?.message || 'Erro desconhecido ao fazer login com Google',
      };
    }
  }

  async completeSignup(userData) {
    try {
      const response = await axios.post(USER_API_URL + 'complete-signup', userData);
      if (response.data.usuario_id) {
        return { success: true, ...response.data };
      }
      return { success: false, message: 'Falha ao completar cadastro' };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Erro desconhecido ao completar cadastro',
      };
    }
  }

  async register(userData) {
    try {
      const response = await axios.post(AUTH_API_URL + 'register', userData);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data || 'Erro desconhecido ao registrar.',
      };
    }
  }

  async forgotPassword(emailData) {
    try {
      const response = await axios.post(AUTH_API_URL + 'forgot-password', emailData);
      return { success: true, message: response.data };
    } catch (error) {
      return { success: false, message: error.response?.data || 'Erro ao solicitar redefinição.' };
    }
  }

  async resetPassword(resetData) {
    try {
      const response = await axios.post(AUTH_API_URL + 'reset-password', resetData);
      return { success: true, message: response.data };
    } catch (error) {
      return { success: false, message: error.response?.data || 'Token inválido ou erro.' };
    }
  }

  async checkUsername(username) {
    try {
      const response = await axios.get(USER_API_URL + 'check-username', {
        params: { username }
      });
      return response.data;
    } catch (error) {
      return { available: false };
    }
  }

  async checkTelefone(telefone) {
    try {
      const response = await axios.get(USER_API_URL + 'check-telefone', {
        params: { telefone }
      });
      return response.data;
    } catch (error) {
      return { available: false };
    }
  }

  handleLoginSuccess(data) {
    const normalizedRole = data.role.startsWith('ROLE_')
      ? data.role
      : `ROLE_${data.role}`;
    localStorage.setItem('token', data.token);
    localStorage.setItem('usuario_id', data.usuario_id);
    localStorage.setItem('role', normalizedRole);
    localStorage.setItem('userName', data.name); 
    localStorage.setItem('userEmail', data.email);
  }

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('usuario_id');
    localStorage.removeItem('role');
    localStorage.removeItem('userName'); 
    localStorage.removeItem('userEmail');
  }

  getCurrentUser() {
    const token = localStorage.getItem('token');
    const usuario_id = localStorage.getItem('usuario_id');
    const role = localStorage.getItem('role');
    const userName = localStorage.getItem('userName'); 
    const userEmail = localStorage.getItem('userEmail'); 
    return token && usuario_id ? { token, usuario_id, role, userName, userEmail } : null;
  }
}

export default new AuthService();